import { formatDate } from 'domain/trip/utils';
import { TRIP_STATUS } from 'domain/trip/constants';
import * as I18n from 'circe/I18n';

export const getLoad = (original) => {
  return {
    stops: getStops(original),
    volume: getVolume(original),
    weight: getWeight(original),
  };
};
export const getVolume = (original) => {
  const value = original?.waybills?.totalVolume?.value;
  return {
    value: value !== null ? Number(value).toFixed(2) : null,
    unit: original?.waybills?.totalVolume?.uom || 'cbm',
  };
};

export const getVolumeUtilization = (original) => {
  try {
    const volumeUtilization = original.waybills.vehicleVolumeUtilization;

    if (volumeUtilization !== null && volumeUtilization !== undefined) {
      return (volumeUtilization * 100).toFixed(2);
    } else {
      return null;
    }
  } catch (e) {
    console.error(e);
    return I18n.str('n/a', 'N/A');
  }
};

export const getWeightUtilization = (original) => {
  try {
    const weightUtilization = original.waybills.vehicleWeightUtilization;

    if (weightUtilization !== null && weightUtilization !== undefined) {
      return (weightUtilization * 100).toFixed(2);
    } else {
      return null;
    }
  } catch (e) {
    console.error(e);
    return I18n.str('n/a', 'N/A');
  }
};

export const getWeight = (original) => {
  const value = original?.waybills?.totalWeight?.value;
  return {
    value: value !== null ? Number(value).toFixed(2) : null,
    unit: original?.waybills?.totalWeight?.uom || 'kg',
  };
};
export const getStops = (original) => {
  return original?.waybills?.totalStops || 0;
};

export const getPlannedStartDate = (original) => {
  return original?.plannedStartDate;
};

export const getPlannedEndDate = (original) => {
  return original?.plannedEndDate;
};

export const getActualStartDate = (original) => {
  return original?.actualStartDate;
};

export const getActualEndDate = (original) => {
  return original?.actualEndDate;
};

export const getStatus = (original) => {
  return original?.status ? TRIP_STATUS[original?.status] : I18n.str('unknown', 'UNKNOWN');
};

export const getDriverInfo = (original) => {
  const profile = {
    name: original?.driverInfo?.name ? original?.driverInfo?.name : null,
    phone: original?.driverInfo?.phone ? original?.driverInfo?.phone : null,
    profileId: original?.driverInfo?.profileId ? original?.driverInfo?.profileId : 'unassigned',
    vehicleLabel: original?.driverInfo?.vehicleLabel ? original?.driverInfo?.vehicleLabel : null,
    vehicleType: original?.driverInfo?.vehicleType ? original?.driverInfo?.vehicleType : null,
    licensePlate: original?.driverInfo?.licensePlate ? original?.driverInfo?.licensePlate : null,
    senderId: original?.senderId ? original?.senderId : 'unassigned',
  };

  return profile;
};

export const getWaybillDriverInfo = (original) => {
  const profile = {
    name: original?.driver?.name ? original?.driver?.name : I18n.str('notAvailable', 'N/A'),
    phone: original?.driver?.phone ? original?.driver?.phone : I18n.str('notAvailable', 'N/A'),
    profileId: original?.driver?.id ? original?.driver?.id : 'unassigned',
  };
  return profile;
};

export const getAlerts = (original) => {
  return original?.alerts || [];
};
export const isAlerting = (original) => {
  return getActiveAlerts(getAlerts(original)).length;
};

export const getActiveAlerts = (alerts) => {
  return alerts.filter((alert) => alert.state === 'ACTIVE');
};

export const getInactiveAlerts = (alerts) => {
  return alerts.filter((alert) => alert.state === 'INACTIVE');
};

export const getDistance = (original) => {
  return {
    value: Number(original?.waybills?.distance?.value || 0).toFixed(2),
    unit: original?.waybills?.distance?.uom || 'km',
  };
};

export const getOptions = (options) => {
  const allOptions = [];
  if (Array.isArray(options)) {
    options?.map((option) => {
      allOptions.push({
        value: option,
        label: option,
      });
    });
  }
  return allOptions;
};

export const getObjectOptions = (options) => {
  const allOptions = [];
  Object.keys(options).map((key) => {
    allOptions.push({
      value: key,
      label: options[key],
    });
  });
  return allOptions;
};

export const mapToOptions = (options) => {
  const allOptions = [];
  if (Array.isArray(options)) {
    options?.map((option) => {
      allOptions.push({
        value: option.code,
        label: localStorage.getItem('locale') === 'ar' ? option.ar : option.en,
      });
    });
  }
  return allOptions;
};
